import { useDispatch, useSelector } from 'react-redux';

import { UploadFile } from 'antd';

import { RootState } from 'app/appStore';
import { addImage, IPostFormState, setFormState } from 'entities/Post';

export const usePostSlice = () => {
	const dispatch = useDispatch();

	return {
		...useSelector((s: RootState) => s.postSlice),
		setFormState: (offset: IPostFormState | null) => dispatch(setFormState(offset)),
		addImage: (image: UploadFile) => dispatch(addImage(image)),
	};
};
